export type Timezone = {
  timezone: string
  offset: number
  offset_dst: number
}

export const TIMEZONES: Timezone[] = [
  { timezone: "Africa/Abidjan", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Accra", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Addis_Ababa", offset: 10800, offset_dst: 10800 },
  { timezone: "Africa/Algiers", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/Asmara", offset: 10800, offset_dst: 10800 },
  { timezone: "Africa/Asmera", offset: 10800, offset_dst: 10800 },
  { timezone: "Africa/Bamako", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Bangui", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/Banjul", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Bissau", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Blantyre", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Brazzaville", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/Bujumbura", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Cairo", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Casablanca", offset: 0, offset_dst: 3600 },
  { timezone: "Africa/Ceuta", offset: 3600, offset_dst: 7200 },
  { timezone: "Africa/Conakry", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Dakar", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Dar_es_Salaam", offset: 10800, offset_dst: 10800 },
  { timezone: "Africa/Djibouti", offset: 10800, offset_dst: 10800 },
  { timezone: "Africa/Douala", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/El_Aaiun", offset: 0, offset_dst: 3600 },
  { timezone: "Africa/Freetown", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Gaborone", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Harare", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Johannesburg", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Juba", offset: 10800, offset_dst: 10800 },
  { timezone: "Africa/Kampala", offset: 10800, offset_dst: 10800 },
  { timezone: "Africa/Khartoum", offset: 10800, offset_dst: 10800 },
  { timezone: "Africa/Kigali", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Kinshasa", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/Lagos", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/Libreville", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/Lome", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Luanda", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/Lubumbashi", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Lusaka", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Malabo", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/Maputo", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Maseru", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Mbabane", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Mogadishu", offset: 10800, offset_dst: 10800 },
  { timezone: "Africa/Monrovia", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Nairobi", offset: 10800, offset_dst: 10800 },
  { timezone: "Africa/Ndjamena", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/Niamey", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/Nouakchott", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Ouagadougou", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Porto-Novo", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/Sao_Tome", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Timbuktu", offset: 0, offset_dst: 0 },
  { timezone: "Africa/Tripoli", offset: 7200, offset_dst: 7200 },
  { timezone: "Africa/Tunis", offset: 3600, offset_dst: 3600 },
  { timezone: "Africa/Windhoek", offset: 3600, offset_dst: 7200 },
  { timezone: "America/Adak", offset: -36000, offset_dst: -32400 },
  { timezone: "America/Anchorage", offset: -32400, offset_dst: -28800 },
  { timezone: "America/Anguilla", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Antigua", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Araguaina", offset: -10800, offset_dst: -10800 },
  {
    timezone: "America/Argentina/Buenos_Aires",
    offset: -10800,
    offset_dst: -10800,
  },
  {
    timezone: "America/Argentina/Catamarca",
    offset: -10800,
    offset_dst: -10800,
  },
  {
    timezone: "America/Argentina/ComodRivadavia",
    offset: -10800,
    offset_dst: -10800,
  },
  { timezone: "America/Argentina/Cordoba", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Argentina/Jujuy", offset: -10800, offset_dst: -10800 },
  {
    timezone: "America/Argentina/La_Rioja",
    offset: -10800,
    offset_dst: -10800,
  },
  { timezone: "America/Argentina/Mendoza", offset: -10800, offset_dst: -10800 },
  {
    timezone: "America/Argentina/Rio_Gallegos",
    offset: -10800,
    offset_dst: -10800,
  },
  { timezone: "America/Argentina/Salta", offset: -10800, offset_dst: -10800 },
  {
    timezone: "America/Argentina/San_Juan",
    offset: -10800,
    offset_dst: -10800,
  },
  {
    timezone: "America/Argentina/San_Luis",
    offset: -10800,
    offset_dst: -10800,
  },
  { timezone: "America/Argentina/Tucuman", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Argentina/Ushuaia", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Aruba", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Asuncion", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Atikokan", offset: -18000, offset_dst: -18000 },
  { timezone: "America/Atka", offset: -36000, offset_dst: -32400 },
  { timezone: "America/Bahia", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Bahia_Banderas", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Barbados", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Belem", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Belize", offset: -21600, offset_dst: -21600 },
  { timezone: "America/Blanc-Sablon", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Boa_Vista", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Bogota", offset: -18000, offset_dst: -18000 },
  { timezone: "America/Boise", offset: -25200, offset_dst: -21600 },
  { timezone: "America/Buenos_Aires", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Cambridge_Bay", offset: -25200, offset_dst: -21600 },
  { timezone: "America/Campo_Grande", offset: -14400, offset_dst: -10800 },
  { timezone: "America/Cancun", offset: -18000, offset_dst: -18000 },
  { timezone: "America/Caracas", offset: -16200, offset_dst: -16200 },
  { timezone: "America/Catamarca", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Cayenne", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Cayman", offset: -18000, offset_dst: -18000 },
  { timezone: "America/Chicago", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Chihuahua", offset: -25200, offset_dst: -21600 },
  { timezone: "America/Coral_Harbour", offset: -18000, offset_dst: -18000 },
  { timezone: "America/Cordoba", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Costa_Rica", offset: -21600, offset_dst: -21600 },
  { timezone: "America/Creston", offset: -25200, offset_dst: -25200 },
  { timezone: "America/Cuiaba", offset: -14400, offset_dst: -10800 },
  { timezone: "America/Curacao", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Danmarkshavn", offset: 0, offset_dst: 0 },
  { timezone: "America/Dawson", offset: -28800, offset_dst: -25200 },
  { timezone: "America/Dawson_Creek", offset: -25200, offset_dst: -25200 },
  { timezone: "America/Denver", offset: -25200, offset_dst: -21600 },
  { timezone: "America/Detroit", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Dominica", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Edmonton", offset: -25200, offset_dst: -21600 },
  { timezone: "America/Eirunepe", offset: -18000, offset_dst: -18000 },
  { timezone: "America/El_Salvador", offset: -21600, offset_dst: -21600 },
  { timezone: "America/Ensenada", offset: -28800, offset_dst: -25200 },
  { timezone: "America/Fort_Nelson", offset: -25200, offset_dst: -25200 },
  { timezone: "America/Fort_Wayne", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Fortaleza", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Glace_Bay", offset: -14400, offset_dst: -10800 },
  { timezone: "America/Godthab", offset: -10800, offset_dst: -7200 },
  { timezone: "America/Goose_Bay", offset: -14400, offset_dst: -10800 },
  { timezone: "America/Grand_Turk", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Grenada", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Guadeloupe", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Guatemala", offset: -21600, offset_dst: -21600 },
  { timezone: "America/Guayaquil", offset: -18000, offset_dst: -18000 },
  { timezone: "America/Guyana", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Halifax", offset: -14400, offset_dst: -10800 },
  { timezone: "America/Havana", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Hermosillo", offset: -25200, offset_dst: -25200 },
  {
    timezone: "America/Indiana/Indianapolis",
    offset: -18000,
    offset_dst: -14400,
  },
  { timezone: "America/Indiana/Knox", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Indiana/Marengo", offset: -18000, offset_dst: -14400 },
  {
    timezone: "America/Indiana/Petersburg",
    offset: -18000,
    offset_dst: -14400,
  },
  { timezone: "America/Indiana/Tell_City", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Indiana/Vevay", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Indiana/Vincennes", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Indiana/Winamac", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Indianapolis", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Inuvik", offset: -25200, offset_dst: -21600 },
  { timezone: "America/Iqaluit", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Jamaica", offset: -18000, offset_dst: -18000 },
  { timezone: "America/Jujuy", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Juneau", offset: -32400, offset_dst: -28800 },
  {
    timezone: "America/Kentucky/Louisville",
    offset: -18000,
    offset_dst: -14400,
  },
  {
    timezone: "America/Kentucky/Monticello",
    offset: -18000,
    offset_dst: -14400,
  },
  { timezone: "America/Knox_IN", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Kralendijk", offset: -14400, offset_dst: -14400 },
  { timezone: "America/La_Paz", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Lima", offset: -18000, offset_dst: -18000 },
  { timezone: "America/Los_Angeles", offset: -28800, offset_dst: -25200 },
  { timezone: "America/Louisville", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Lower_Princes", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Maceio", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Managua", offset: -21600, offset_dst: -21600 },
  { timezone: "America/Manaus", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Marigot", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Martinique", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Matamoros", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Mazatlan", offset: -25200, offset_dst: -21600 },
  { timezone: "America/Mendoza", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Menominee", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Merida", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Metlakatla", offset: -28800, offset_dst: -28800 },
  { timezone: "America/Mexico_City", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Miquelon", offset: -10800, offset_dst: -7200 },
  { timezone: "America/Moncton", offset: -14400, offset_dst: -10800 },
  { timezone: "America/Monterrey", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Montevideo", offset: -10800, offset_dst: -7200 },
  { timezone: "America/Montreal", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Montserrat", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Nassau", offset: -18000, offset_dst: -14400 },
  { timezone: "America/New_York", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Nipigon", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Nome", offset: -32400, offset_dst: -28800 },
  { timezone: "America/Noronha", offset: -7200, offset_dst: -7200 },
  {
    timezone: "America/North_Dakota/Beulah",
    offset: -21600,
    offset_dst: -18000,
  },
  {
    timezone: "America/North_Dakota/Center",
    offset: -21600,
    offset_dst: -18000,
  },
  {
    timezone: "America/North_Dakota/New_Salem",
    offset: -21600,
    offset_dst: -18000,
  },
  { timezone: "America/Ojinaga", offset: -25200, offset_dst: -21600 },
  { timezone: "America/Panama", offset: -18000, offset_dst: -18000 },
  { timezone: "America/Pangnirtung", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Paramaribo", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Phoenix", offset: -25200, offset_dst: -25200 },
  { timezone: "America/Port-au-Prince", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Port_of_Spain", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Porto_Acre", offset: -18000, offset_dst: -18000 },
  { timezone: "America/Porto_Velho", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Puerto_Rico", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Rainy_River", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Rankin_Inlet", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Recife", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Regina", offset: -21600, offset_dst: -21600 },
  { timezone: "America/Resolute", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Rio_Branco", offset: -18000, offset_dst: -18000 },
  { timezone: "America/Rosario", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Santa_Isabel", offset: -28800, offset_dst: -25200 },
  { timezone: "America/Santarem", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Santiago", offset: -10800, offset_dst: -10800 },
  { timezone: "America/Santo_Domingo", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Sao_Paulo", offset: -10800, offset_dst: -7200 },
  { timezone: "America/Scoresbysund", offset: -3600, offset_dst: 0 },
  { timezone: "America/Shiprock", offset: -25200, offset_dst: -21600 },
  { timezone: "America/Sitka", offset: -32400, offset_dst: -28800 },
  { timezone: "America/St_Barthelemy", offset: -14400, offset_dst: -14400 },
  { timezone: "America/St_Johns", offset: -12600, offset_dst: -9000 },
  { timezone: "America/St_Kitts", offset: -14400, offset_dst: -14400 },
  { timezone: "America/St_Lucia", offset: -14400, offset_dst: -14400 },
  { timezone: "America/St_Thomas", offset: -14400, offset_dst: -14400 },
  { timezone: "America/St_Vincent", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Swift_Current", offset: -21600, offset_dst: -21600 },
  { timezone: "America/Tegucigalpa", offset: -21600, offset_dst: -21600 },
  { timezone: "America/Thule", offset: -14400, offset_dst: -10800 },
  { timezone: "America/Thunder_Bay", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Tijuana", offset: -28800, offset_dst: -25200 },
  { timezone: "America/Toronto", offset: -18000, offset_dst: -14400 },
  { timezone: "America/Tortola", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Vancouver", offset: -28800, offset_dst: -25200 },
  { timezone: "America/Virgin", offset: -14400, offset_dst: -14400 },
  { timezone: "America/Whitehorse", offset: -28800, offset_dst: -25200 },
  { timezone: "America/Winnipeg", offset: -21600, offset_dst: -18000 },
  { timezone: "America/Yakutat", offset: -32400, offset_dst: -28800 },
  { timezone: "America/Yellowknife", offset: -25200, offset_dst: -21600 },
  { timezone: "Antarctica/Casey", offset: 28800, offset_dst: 28800 },
  { timezone: "Antarctica/Davis", offset: 25200, offset_dst: 25200 },
  { timezone: "Antarctica/DumontDUrville", offset: 36000, offset_dst: 36000 },
  { timezone: "Antarctica/Macquarie", offset: 39600, offset_dst: 39600 },
  { timezone: "Antarctica/Mawson", offset: 18000, offset_dst: 18000 },
  { timezone: "Antarctica/McMurdo", offset: 43200, offset_dst: 46800 },
  { timezone: "Antarctica/Palmer", offset: -10800, offset_dst: -10800 },
  { timezone: "Antarctica/Rothera", offset: -10800, offset_dst: -10800 },
  { timezone: "Antarctica/South_Pole", offset: 43200, offset_dst: 46800 },
  { timezone: "Antarctica/Syowa", offset: 10800, offset_dst: 10800 },
  { timezone: "Antarctica/Troll", offset: 0, offset_dst: 7200 },
  { timezone: "Antarctica/Vostok", offset: 21600, offset_dst: 21600 },
  { timezone: "Arctic/Longyearbyen", offset: 3600, offset_dst: 7200 },
  { timezone: "Asia/Aden", offset: 10800, offset_dst: 10800 },
  { timezone: "Asia/Almaty", offset: 21600, offset_dst: 21600 },
  { timezone: "Asia/Amman", offset: 7200, offset_dst: 10800 },
  { timezone: "Asia/Anadyr", offset: 43200, offset_dst: 43200 },
  { timezone: "Asia/Aqtau", offset: 18000, offset_dst: 18000 },
  { timezone: "Asia/Aqtobe", offset: 18000, offset_dst: 18000 },
  { timezone: "Asia/Ashgabat", offset: 18000, offset_dst: 18000 },
  { timezone: "Asia/Ashkhabad", offset: 18000, offset_dst: 18000 },
  { timezone: "Asia/Baghdad", offset: 10800, offset_dst: 10800 },
  { timezone: "Asia/Bahrain", offset: 10800, offset_dst: 10800 },
  { timezone: "Asia/Baku", offset: 14400, offset_dst: 18000 },
  { timezone: "Asia/Bangkok", offset: 25200, offset_dst: 25200 },
  { timezone: "Asia/Beirut", offset: 7200, offset_dst: 10800 },
  { timezone: "Asia/Bishkek", offset: 21600, offset_dst: 21600 },
  { timezone: "Asia/Brunei", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Calcutta", offset: 19800, offset_dst: 19800 },
  { timezone: "Asia/Chita", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Choibalsan", offset: 28800, offset_dst: 32400 },
  { timezone: "Asia/Chongqing", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Chungking", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Colombo", offset: 19800, offset_dst: 19800 },
  { timezone: "Asia/Dacca", offset: 21600, offset_dst: 21600 },
  { timezone: "Asia/Damascus", offset: 7200, offset_dst: 10800 },
  { timezone: "Asia/Dhaka", offset: 21600, offset_dst: 21600 },
  { timezone: "Asia/Dili", offset: 32400, offset_dst: 32400 },
  { timezone: "Asia/Dubai", offset: 14400, offset_dst: 14400 },
  { timezone: "Asia/Dushanbe", offset: 18000, offset_dst: 18000 },
  { timezone: "Asia/Gaza", offset: 7200, offset_dst: 10800 },
  { timezone: "Asia/Harbin", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Hebron", offset: 7200, offset_dst: 10800 },
  { timezone: "Asia/Ho_Chi_Minh", offset: 25200, offset_dst: 25200 },
  { timezone: "Asia/Hong_Kong", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Hovd", offset: 25200, offset_dst: 28800 },
  { timezone: "Asia/Irkutsk", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Istanbul", offset: 7200, offset_dst: 10800 },
  { timezone: "Asia/Jakarta", offset: 25200, offset_dst: 25200 },
  { timezone: "Asia/Jayapura", offset: 32400, offset_dst: 32400 },
  { timezone: "Asia/Jerusalem", offset: 7200, offset_dst: 10800 },
  { timezone: "Asia/Kabul", offset: 16200, offset_dst: 16200 },
  { timezone: "Asia/Kamchatka", offset: 43200, offset_dst: 43200 },
  { timezone: "Asia/Karachi", offset: 18000, offset_dst: 18000 },
  { timezone: "Asia/Kashgar", offset: 21600, offset_dst: 21600 },
  { timezone: "Asia/Kathmandu", offset: 20700, offset_dst: 20700 },
  { timezone: "Asia/Katmandu", offset: 20700, offset_dst: 20700 },
  { timezone: "Asia/Khandyga", offset: 32400, offset_dst: 32400 },
  { timezone: "Asia/Kolkata", offset: 19800, offset_dst: 19800 },
  { timezone: "Asia/Krasnoyarsk", offset: 25200, offset_dst: 25200 },
  { timezone: "Asia/Kuala_Lumpur", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Kuching", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Kuwait", offset: 10800, offset_dst: 10800 },
  { timezone: "Asia/Macao", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Macau", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Magadan", offset: 36000, offset_dst: 36000 },
  { timezone: "Asia/Makassar", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Manila", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Muscat", offset: 14400, offset_dst: 14400 },
  { timezone: "Asia/Nicosia", offset: 7200, offset_dst: 10800 },
  { timezone: "Asia/Novokuznetsk", offset: 25200, offset_dst: 25200 },
  { timezone: "Asia/Novosibirsk", offset: 21600, offset_dst: 21600 },
  { timezone: "Asia/Omsk", offset: 21600, offset_dst: 21600 },
  { timezone: "Asia/Oral", offset: 18000, offset_dst: 18000 },
  { timezone: "Asia/Phnom_Penh", offset: 25200, offset_dst: 25200 },
  { timezone: "Asia/Pontianak", offset: 25200, offset_dst: 25200 },
  { timezone: "Asia/Pyongyang", offset: 30600, offset_dst: 30600 },
  { timezone: "Asia/Qatar", offset: 10800, offset_dst: 10800 },
  { timezone: "Asia/Qyzylorda", offset: 21600, offset_dst: 21600 },
  { timezone: "Asia/Rangoon", offset: 23400, offset_dst: 23400 },
  { timezone: "Asia/Riyadh", offset: 10800, offset_dst: 10800 },
  { timezone: "Asia/Riyadh87", offset: 10800, offset_dst: 10800 },
  { timezone: "Asia/Riyadh88", offset: 10800, offset_dst: 10800 },
  { timezone: "Asia/Riyadh89", offset: 10800, offset_dst: 10800 },
  { timezone: "Asia/Saigon", offset: 25200, offset_dst: 25200 },
  { timezone: "Asia/Sakhalin", offset: 36000, offset_dst: 36000 },
  { timezone: "Asia/Samarkand", offset: 18000, offset_dst: 18000 },
  { timezone: "Asia/Seoul", offset: 32400, offset_dst: 32400 },
  { timezone: "Asia/Shanghai", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Singapore", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Srednekolymsk", offset: 39600, offset_dst: 39600 },
  { timezone: "Asia/Taipei", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Tashkent", offset: 18000, offset_dst: 18000 },
  { timezone: "Asia/Tbilisi", offset: 14400, offset_dst: 14400 },
  { timezone: "Asia/Tehran", offset: 12600, offset_dst: 16200 },
  { timezone: "Asia/Tel_Aviv", offset: 7200, offset_dst: 10800 },
  { timezone: "Asia/Thimbu", offset: 21600, offset_dst: 21600 },
  { timezone: "Asia/Thimphu", offset: 21600, offset_dst: 21600 },
  { timezone: "Asia/Tokyo", offset: 32400, offset_dst: 32400 },
  { timezone: "Asia/Ujung_Pandang", offset: 28800, offset_dst: 28800 },
  { timezone: "Asia/Ulaanbaatar", offset: 28800, offset_dst: 32400 },
  { timezone: "Asia/Ulan_Bator", offset: 28800, offset_dst: 32400 },
  { timezone: "Asia/Urumqi", offset: 21600, offset_dst: 21600 },
  { timezone: "Asia/Vientiane", offset: 25200, offset_dst: 25200 },
  { timezone: "Asia/Vladivostok", offset: 36000, offset_dst: 36000 },
  { timezone: "Asia/Yakutsk", offset: 32400, offset_dst: 32400 },
  { timezone: "Asia/Yekaterinburg", offset: 18000, offset_dst: 18000 },
  { timezone: "Asia/Yerevan", offset: 14400, offset_dst: 14400 },
  { timezone: "Atlantic/Azores", offset: -3600, offset_dst: 0 },
  { timezone: "Atlantic/Bermuda", offset: -14400, offset_dst: -10800 },
  { timezone: "Atlantic/Canary", offset: 0, offset_dst: 3600 },
  { timezone: "Atlantic/Cape_Verde", offset: -3600, offset_dst: -3600 },
  { timezone: "Atlantic/Faeroe", offset: 0, offset_dst: 3600 },
  { timezone: "Atlantic/Faroe", offset: 0, offset_dst: 3600 },
  { timezone: "Atlantic/Jan_Mayen", offset: 3600, offset_dst: 7200 },
  { timezone: "Atlantic/Madeira", offset: 0, offset_dst: 3600 },
  { timezone: "Atlantic/Reykjavik", offset: 0, offset_dst: 0 },
  { timezone: "Atlantic/South_Georgia", offset: -7200, offset_dst: -7200 },
  { timezone: "Atlantic/St_Helena", offset: 0, offset_dst: 0 },
  { timezone: "Atlantic/Stanley", offset: -10800, offset_dst: -10800 },
  { timezone: "Australia/ACT", offset: 36000, offset_dst: 39600 },
  { timezone: "Australia/Adelaide", offset: 34200, offset_dst: 37800 },
  { timezone: "Australia/Brisbane", offset: 36000, offset_dst: 36000 },
  { timezone: "Australia/Broken_Hill", offset: 34200, offset_dst: 37800 },
  { timezone: "Australia/Canberra", offset: 36000, offset_dst: 39600 },
  { timezone: "Australia/Currie", offset: 36000, offset_dst: 39600 },
  { timezone: "Australia/Darwin", offset: 34200, offset_dst: 34200 },
  { timezone: "Australia/Eucla", offset: 31500, offset_dst: 31500 },
  { timezone: "Australia/Hobart", offset: 36000, offset_dst: 39600 },
  { timezone: "Australia/LHI", offset: 37800, offset_dst: 39600 },
  { timezone: "Australia/Lindeman", offset: 36000, offset_dst: 36000 },
  { timezone: "Australia/Lord_Howe", offset: 37800, offset_dst: 39600 },
  { timezone: "Australia/Melbourne", offset: 36000, offset_dst: 39600 },
  { timezone: "Australia/NSW", offset: 36000, offset_dst: 39600 },
  { timezone: "Australia/North", offset: 34200, offset_dst: 34200 },
  { timezone: "Australia/Perth", offset: 28800, offset_dst: 28800 },
  { timezone: "Australia/Queensland", offset: 36000, offset_dst: 36000 },
  { timezone: "Australia/South", offset: 34200, offset_dst: 37800 },
  { timezone: "Australia/Sydney", offset: 36000, offset_dst: 39600 },
  { timezone: "Australia/Tasmania", offset: 36000, offset_dst: 39600 },
  { timezone: "Australia/Victoria", offset: 36000, offset_dst: 39600 },
  { timezone: "Australia/West", offset: 28800, offset_dst: 28800 },
  { timezone: "Australia/Yancowinna", offset: 34200, offset_dst: 37800 },
  { timezone: "Brazil/Acre", offset: -18000, offset_dst: -18000 },
  { timezone: "Brazil/DeNoronha", offset: -7200, offset_dst: -7200 },
  { timezone: "Brazil/East", offset: -10800, offset_dst: -7200 },
  { timezone: "Brazil/West", offset: -14400, offset_dst: -14400 },
  { timezone: "CET", offset: 3600, offset_dst: 7200 },
  { timezone: "CST6CDT", offset: -21600, offset_dst: -18000 },
  { timezone: "Canada/Atlantic", offset: -14400, offset_dst: -10800 },
  { timezone: "Canada/Central", offset: -21600, offset_dst: -18000 },
  { timezone: "Canada/East-Saskatchewan", offset: -21600, offset_dst: -21600 },
  { timezone: "Canada/Eastern", offset: -18000, offset_dst: -14400 },
  { timezone: "Canada/Mountain", offset: -25200, offset_dst: -21600 },
  { timezone: "Canada/Newfoundland", offset: -12600, offset_dst: -9000 },
  { timezone: "Canada/Pacific", offset: -28800, offset_dst: -25200 },
  { timezone: "Canada/Saskatchewan", offset: -21600, offset_dst: -21600 },
  { timezone: "Canada/Yukon", offset: -28800, offset_dst: -25200 },
  { timezone: "Chile/Continental", offset: -10800, offset_dst: -10800 },
  { timezone: "Chile/EasterIsland", offset: -18000, offset_dst: -18000 },
  { timezone: "Cuba", offset: -18000, offset_dst: -14400 },
  { timezone: "EET", offset: 7200, offset_dst: 10800 },
  { timezone: "EST", offset: -18000, offset_dst: -18000 },
  { timezone: "EST5EDT", offset: -18000, offset_dst: -14400 },
  { timezone: "Egypt", offset: 7200, offset_dst: 7200 },
  { timezone: "Eire", offset: 0, offset_dst: 3600 },
  { timezone: "Etc/GMT", offset: 0, offset_dst: 0 },
  { timezone: "Etc/GMT+0", offset: 0, offset_dst: 0 },
  { timezone: "Etc/GMT+1", offset: -3600, offset_dst: -3600 },
  { timezone: "Etc/GMT+10", offset: -36000, offset_dst: -36000 },
  { timezone: "Etc/GMT+11", offset: -39600, offset_dst: -39600 },
  { timezone: "Etc/GMT+12", offset: -43200, offset_dst: -43200 },
  { timezone: "Etc/GMT+2", offset: -7200, offset_dst: -7200 },
  { timezone: "Etc/GMT+3", offset: -10800, offset_dst: -10800 },
  { timezone: "Etc/GMT+4", offset: -14400, offset_dst: -14400 },
  { timezone: "Etc/GMT+5", offset: -18000, offset_dst: -18000 },
  { timezone: "Etc/GMT+6", offset: -21600, offset_dst: -21600 },
  { timezone: "Etc/GMT+7", offset: -25200, offset_dst: -25200 },
  { timezone: "Etc/GMT+8", offset: -28800, offset_dst: -28800 },
  { timezone: "Etc/GMT+9", offset: -32400, offset_dst: -32400 },
  { timezone: "Etc/GMT-0", offset: 0, offset_dst: 0 },
  { timezone: "Etc/GMT-1", offset: 3600, offset_dst: 3600 },
  { timezone: "Etc/GMT-10", offset: 36000, offset_dst: 36000 },
  { timezone: "Etc/GMT-11", offset: 39600, offset_dst: 39600 },
  { timezone: "Etc/GMT-12", offset: 43200, offset_dst: 43200 },
  { timezone: "Etc/GMT-13", offset: 46800, offset_dst: 46800 },
  { timezone: "Etc/GMT-14", offset: 50400, offset_dst: 50400 },
  { timezone: "Etc/GMT-2", offset: 7200, offset_dst: 7200 },
  { timezone: "Etc/GMT-3", offset: 10800, offset_dst: 10800 },
  { timezone: "Etc/GMT-4", offset: 14400, offset_dst: 14400 },
  { timezone: "Etc/GMT-5", offset: 18000, offset_dst: 18000 },
  { timezone: "Etc/GMT-6", offset: 21600, offset_dst: 21600 },
  { timezone: "Etc/GMT-7", offset: 25200, offset_dst: 25200 },
  { timezone: "Etc/GMT-8", offset: 28800, offset_dst: 28800 },
  { timezone: "Etc/GMT-9", offset: 32400, offset_dst: 32400 },
  { timezone: "Etc/GMT0", offset: 0, offset_dst: 0 },
  { timezone: "Etc/Greenwich", offset: 0, offset_dst: 0 },
  { timezone: "Etc/UCT", offset: 0, offset_dst: 0 },
  { timezone: "Etc/UTC", offset: 0, offset_dst: 0 },
  { timezone: "Etc/Universal", offset: 0, offset_dst: 0 },
  { timezone: "Etc/Zulu", offset: 0, offset_dst: 0 },
  { timezone: "Europe/Amsterdam", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Andorra", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Athens", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Belfast", offset: 0, offset_dst: 3600 },
  { timezone: "Europe/Belgrade", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Berlin", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Bratislava", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Brussels", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Bucharest", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Budapest", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Busingen", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Chisinau", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Copenhagen", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Dublin", offset: 0, offset_dst: 3600 },
  { timezone: "Europe/Gibraltar", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Guernsey", offset: 0, offset_dst: 3600 },
  { timezone: "Europe/Helsinki", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Isle_of_Man", offset: 0, offset_dst: 3600 },
  { timezone: "Europe/Istanbul", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Jersey", offset: 0, offset_dst: 3600 },
  { timezone: "Europe/Kaliningrad", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Kiev", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Lisbon", offset: 0, offset_dst: 3600 },
  { timezone: "Europe/Ljubljana", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/London", offset: 0, offset_dst: 3600 },
  { timezone: "Europe/Luxembourg", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Madrid", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Malta", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Mariehamn", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Minsk", offset: 10800, offset_dst: 10800 },
  { timezone: "Europe/Monaco", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Moscow", offset: 10800, offset_dst: 10800 },
  { timezone: "Europe/Nicosia", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Oslo", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Paris", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Podgorica", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Prague", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Riga", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Rome", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Samara", offset: 14400, offset_dst: 14400 },
  { timezone: "Europe/San_Marino", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Sarajevo", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Simferopol", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Skopje", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Sofia", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Stockholm", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Tallinn", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Tirane", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Tiraspol", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Uzhgorod", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Vaduz", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Vatican", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Vienna", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Vilnius", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Volgograd", offset: 10800, offset_dst: 10800 },
  { timezone: "Europe/Warsaw", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Zagreb", offset: 3600, offset_dst: 7200 },
  { timezone: "Europe/Zaporozhye", offset: 7200, offset_dst: 10800 },
  { timezone: "Europe/Zurich", offset: 3600, offset_dst: 7200 },
  { timezone: "Factory", offset: 0, offset_dst: 0 },
  { timezone: "GB", offset: 0, offset_dst: 3600 },
  { timezone: "GB-Eire", offset: 0, offset_dst: 3600 },
  { timezone: "GMT", offset: 0, offset_dst: 0 },
  { timezone: "GMT+0", offset: 0, offset_dst: 0 },
  { timezone: "GMT-0", offset: 0, offset_dst: 0 },
  { timezone: "GMT0", offset: 0, offset_dst: 0 },
  { timezone: "Greenwich", offset: 0, offset_dst: 0 },
  { timezone: "HST", offset: -36000, offset_dst: -36000 },
  { timezone: "Hongkong", offset: 28800, offset_dst: 28800 },
  { timezone: "Iceland", offset: 0, offset_dst: 0 },
  { timezone: "Indian/Antananarivo", offset: 10800, offset_dst: 10800 },
  { timezone: "Indian/Chagos", offset: 21600, offset_dst: 21600 },
  { timezone: "Indian/Christmas", offset: 25200, offset_dst: 25200 },
  { timezone: "Indian/Cocos", offset: 23400, offset_dst: 23400 },
  { timezone: "Indian/Comoro", offset: 10800, offset_dst: 10800 },
  { timezone: "Indian/Kerguelen", offset: 18000, offset_dst: 18000 },
  { timezone: "Indian/Mahe", offset: 14400, offset_dst: 14400 },
  { timezone: "Indian/Maldives", offset: 18000, offset_dst: 18000 },
  { timezone: "Indian/Mauritius", offset: 14400, offset_dst: 14400 },
  { timezone: "Indian/Mayotte", offset: 10800, offset_dst: 10800 },
  { timezone: "Indian/Reunion", offset: 14400, offset_dst: 14400 },
  { timezone: "Iran", offset: 12600, offset_dst: 16200 },
  { timezone: "Israel", offset: 7200, offset_dst: 10800 },
  { timezone: "Jamaica", offset: -18000, offset_dst: -18000 },
  { timezone: "Japan", offset: 32400, offset_dst: 32400 },
  { timezone: "Kwajalein", offset: 43200, offset_dst: 43200 },
  { timezone: "Libya", offset: 7200, offset_dst: 7200 },
  { timezone: "MET", offset: 3600, offset_dst: 7200 },
  { timezone: "MST", offset: -25200, offset_dst: -25200 },
  { timezone: "MST7MDT", offset: -25200, offset_dst: -21600 },
  { timezone: "Mexico/BajaNorte", offset: -28800, offset_dst: -25200 },
  { timezone: "Mexico/BajaSur", offset: -25200, offset_dst: -21600 },
  { timezone: "Mexico/General", offset: -21600, offset_dst: -18000 },
  { timezone: "Mideast/Riyadh87", offset: 0, offset_dst: 0 },
  { timezone: "Mideast/Riyadh88", offset: 0, offset_dst: 0 },
  { timezone: "Mideast/Riyadh89", offset: 0, offset_dst: 0 },
  { timezone: "NZ", offset: 43200, offset_dst: 46800 },
  { timezone: "NZ-CHAT", offset: 45900, offset_dst: 49500 },
  { timezone: "Navajo", offset: 0, offset_dst: 0 },
  { timezone: "PRC", offset: 0, offset_dst: 0 },
  { timezone: "PST8PDT", offset: 0, offset_dst: 0 },
  { timezone: "Pacific/Apia", offset: 46800, offset_dst: 50400 },
  { timezone: "Pacific/Auckland", offset: 43200, offset_dst: 46800 },
  { timezone: "Pacific/Bougainville", offset: 39600, offset_dst: 39600 },
  { timezone: "Pacific/Chatham", offset: 45900, offset_dst: 49500 },
  { timezone: "Pacific/Chuuk", offset: 36000, offset_dst: 36000 },
  { timezone: "Pacific/Easter", offset: -18000, offset_dst: -18000 },
  { timezone: "Pacific/Efate", offset: 39600, offset_dst: 39600 },
  { timezone: "Pacific/Enderbury", offset: 46800, offset_dst: 46800 },
  { timezone: "Pacific/Fakaofo", offset: 46800, offset_dst: 46800 },
  { timezone: "Pacific/Fiji", offset: 43200, offset_dst: 46800 },
  { timezone: "Pacific/Funafuti", offset: 43200, offset_dst: 43200 },
  { timezone: "Pacific/Galapagos", offset: -21600, offset_dst: -21600 },
  { timezone: "Pacific/Gambier", offset: -32400, offset_dst: -32400 },
  { timezone: "Pacific/Guadalcanal", offset: 39600, offset_dst: 39600 },
  { timezone: "Pacific/Guam", offset: 36000, offset_dst: 36000 },
  { timezone: "Pacific/Honolulu", offset: -36000, offset_dst: -36000 },
  { timezone: "Pacific/Johnston", offset: -36000, offset_dst: -36000 },
  { timezone: "Pacific/Kiritimati", offset: 50400, offset_dst: 50400 },
  { timezone: "Pacific/Kosrae", offset: 39600, offset_dst: 39600 },
  { timezone: "Pacific/Kwajalein", offset: 43200, offset_dst: 43200 },
  { timezone: "Pacific/Majuro", offset: 43200, offset_dst: 43200 },
  { timezone: "Pacific/Marquesas", offset: -34200, offset_dst: -34200 },
  { timezone: "Pacific/Midway", offset: -39600, offset_dst: -39600 },
  { timezone: "Pacific/Nauru", offset: 43200, offset_dst: 43200 },
  { timezone: "Pacific/Niue", offset: -39600, offset_dst: -39600 },
  { timezone: "Pacific/Norfolk", offset: 39600, offset_dst: 39600 },
  { timezone: "Pacific/Noumea", offset: 39600, offset_dst: 39600 },
  { timezone: "Pacific/Pago_Pago", offset: -39600, offset_dst: -39600 },
  { timezone: "Pacific/Palau", offset: 32400, offset_dst: 32400 },
  { timezone: "Pacific/Pitcairn", offset: -28800, offset_dst: -28800 },
  { timezone: "Pacific/Ponape", offset: 39600, offset_dst: 39600 },
  { timezone: "Pacific/Port_Moresby", offset: 36000, offset_dst: 36000 },
  { timezone: "Pacific/Rarotonga", offset: -36000, offset_dst: -36000 },
  { timezone: "Pacific/Saipan", offset: 36000, offset_dst: 36000 },
  { timezone: "Pacific/Samoa", offset: -39600, offset_dst: -39600 },
  { timezone: "Pacific/Tahiti", offset: -36000, offset_dst: -36000 },
  { timezone: "Pacific/Tarawa", offset: 43200, offset_dst: 43200 },
  { timezone: "Pacific/Tongatapu", offset: 46800, offset_dst: 46800 },
  { timezone: "Pacific/Truk", offset: 36000, offset_dst: 36000 },
  { timezone: "Pacific/Wake", offset: 43200, offset_dst: 43200 },
  { timezone: "Pacific/Wallis", offset: 43200, offset_dst: 43200 },
  { timezone: "Pacific/Yap", offset: 36000, offset_dst: 36000 },
  { timezone: "Poland", offset: 3600, offset_dst: 7200 },
  { timezone: "Portugal", offset: 0, offset_dst: 3600 },
  { timezone: "ROC", offset: 28800, offset_dst: 28800 },
  { timezone: "ROK", offset: 32400, offset_dst: 32400 },
  { timezone: "Singapore", offset: 28800, offset_dst: 28800 },
  { timezone: "Turkey", offset: 7200, offset_dst: 10800 },
  { timezone: "UCT", offset: 0, offset_dst: 0 },
  { timezone: "US/Alaska", offset: -32400, offset_dst: -28800 },
  { timezone: "US/Aleutian", offset: -36000, offset_dst: -32400 },
  { timezone: "US/Arizona", offset: -25200, offset_dst: -25200 },
  { timezone: "US/Central", offset: -21600, offset_dst: -18000 },
  { timezone: "US/East-Indiana", offset: -18000, offset_dst: -14400 },
  { timezone: "US/Eastern", offset: -18000, offset_dst: -14400 },
  { timezone: "US/Hawaii", offset: -36000, offset_dst: -36000 },
  { timezone: "US/Indiana-Starke", offset: -21600, offset_dst: -18000 },
  { timezone: "US/Michigan", offset: -18000, offset_dst: -14400 },
  { timezone: "US/Mountain", offset: -25200, offset_dst: -21600 },
  { timezone: "US/Pacific", offset: -28800, offset_dst: -25200 },
  { timezone: "US/Pacific-New", offset: -28800, offset_dst: -25200 },
  { timezone: "US/Samoa", offset: -39600, offset_dst: -39600 },
  { timezone: "UTC", offset: 0, offset_dst: 0 },
  { timezone: "Universal", offset: 0, offset_dst: 0 },
  { timezone: "W-SU", offset: 10800, offset_dst: 10800 },
  { timezone: "WET", offset: 0, offset_dst: 3600 },
  { timezone: "Zulu", offset: 0, offset_dst: 0 },
]

// Helper function to format timezone for display with offset
export function formatTimezoneLabel(tz: Timezone): string {
  const hours = Math.floor(Math.abs(tz.offset) / 3600)
  const minutes = (Math.abs(tz.offset) % 3600) / 60
  const sign = tz.offset >= 0 ? "+" : "-"
  const offsetStr = `UTC${sign}${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`
  return `${tz.timezone} (${offsetStr})`
}

// Helper function to convert timezones to combobox options
export function getTimezoneOptions() {
  return TIMEZONES.map((tz, index) => ({
    id: index,
    label: formatTimezoneLabel(tz),
    value: tz.timezone,
  }))
}
